export var reduxKey = '@@DUPERBROWSE';
export var actionKey = '@@DUPERBROWSE';
export var initialState = {
    streamStack: [],
    isSessionActive: false,
    isHistoryManagementEnabled: true,
};
//# sourceMappingURL=constants.js.map